import { Component, OnInit, AfterViewInit, TemplateRef, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

export interface FeatureTab<T> {
	key: T;
	template: TemplateRef<any>;
	label: string;
	isLabelIcon?: boolean;
	tooltip?: string;
	hidden?: boolean;
	tempHidden?: boolean; // temporary hidden for cases like topo fix
	disabled?: boolean;
}

@Component({
	selector: 'app-feature-vertical-tabs',
	templateUrl: './feature-vertical-tabs.component.html',
	styleUrls: ['./feature-vertical-tabs.component.css']
})
export class FeatureVerticalTabsComponent implements OnInit, AfterViewInit, OnChanges {

	@Input() tabs: FeatureTab<any>[] = [];
	@Input() disableSwitchingTab: boolean;
	// @Input() isProtectOn: boolean; // If on, warn user on switch tabs

	selectedTab: FeatureTab<any>;

	constructedTabs: FeatureTab<any>[] = [];

	@Output() changeTab: EventEmitter<FeatureTab<any>> = new EventEmitter();
	constructor() { }

	async selectTab(idx: number) {
		if (this.disableSwitchingTab) {
			return;
		}
		if (this.tabs[idx].disabled) {
			return;
		}
		this.selectedTab = this.tabs[idx];
		if (!this.constructedTabs.find(t => t.key === this.selectedTab.key)) {
			this.constructedTabs.push(this.selectedTab);
		}
		this.changeTab.emit(this.selectedTab);
	}
	private setInitTab() {
		if (this.tabs && this.tabs.length) {
			this.selectTab(0);
		}
	}
	ngOnInit() {
		this.setInitTab();
	}
	ngAfterViewInit() {

	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.tabs && changes.tabs.currentValue) {
			this.setInitTab();
		}
	}

}
